module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-600.df4b4c0c.svg";